import React from 'react';
import Arrow from './assets/images/arrow-rule-left1.png';
import Anchor from './pageElements/anchor';

const Button = (props) => (
  <div className={props.className} style={{
    backgroundImage:props.bgi,
    backgroundColor:props.bgc,
    backgroundRepeat:props.bgr,
    backgroundSize:props.bgs,
    backgroundPosition:props.bgp, 
    ...props.styles}}>    
    <Anchor id={props.id} className={props.linkStyle} tabIndex="0" href={props.url} styles={{textDecoration:"none"}}>{props.children}</Anchor>
  </div> 
);

Button.defaultProps= {
  bgc:"#66ac47",
  url:"https://uvm.edu",
  bgi:"url("+Arrow+")",
  bgr:"no-repeat",
  bgs:"45px 45px",
  bgp:"right", 
  children:"Button Text",
}

export default Button;